export function headerInit() {
	document.addEventListener( 'DOMContentLoaded', function() {
		// Header open logic
		const openMobileHeader = () => {
			document.getElementById( 'site-navigation' ).classList.toggle( 'active' );
			document.getElementById( 'mobile-nav-close' ).focus();
		};
		const closeMobileHeader = () => {
			document.getElementById( 'site-navigation' ).classList.toggle( 'active' );
			document.getElementById( 'mobile-nav-open' ).focus();
		};

		document.getElementById( 'mobile-nav-open' ).addEventListener( 'click', openMobileHeader );
		document.getElementById( 'mobile-nav-close' ).addEventListener( 'click', closeMobileHeader );

		// Header scroll logic
		let prevScroll = window.scrollY;
		const header = document.querySelector( 'header' );
		const top = header.offsetTop + 130;

		window.onscroll = () => {
			const currentScroll = window.scrollY;

			if ( currentScroll >= top ) {
				header.classList.add( 'sticky' );
			} else {
				header.classList.remove( 'sticky' );
			}

			if ( prevScroll >= currentScroll ) {
				header.style.top = '0';
			} else {
				header.style.top = '-300px';
			}

			prevScroll = currentScroll;
		};

		const search = document.getElementById( 'header-search' );
		const searchLabel = search.getElementsByClassName( 'site-header-menu-search-label' )[ 0 ];
		const searchInput = search.getElementsByClassName( 'search-field' )[ 0 ];
		const searchSubmit = search.getElementsByClassName( 'search-submit' )[ 0 ];
		const searchClose = search.getElementsByClassName( 'search-close' )[ 0 ];

		const openSearch = () => {
			search.classList.add( 'search__open' );
			searchInput.focus();
			if ( ! searchInput.value ) {
				searchLabel.style.display = 'none';
			} else {
				searchLabel.style.display = 'block';
			}
		};

		const closeSearch = () => {
			search.classList.remove( 'search__open' );
			searchLabel.style.display = 'flex';
		};

		searchLabel.onclick = function( e ) {
			e.preventDefault();
			if ( search.classList.contains( 'search__open' ) ) {
				searchSubmit.click();
			} else {
				openSearch();
			}

			e.stopPropagation();
		};
		searchInput.onclick = function( e ) {
			openSearch();
			e.stopPropagation();
		};
		searchInput.onkeydown = function( e ) {
			if ( ( e.key === 'Backspace' || e.key === 'Delete' ) && searchInput.value.length <= 1 ) {
				searchLabel.style.display = 'none';
			} else {
				searchLabel.style.display = 'block';
			}
		};
		searchInput.onkeyup = function() {
			if ( searchInput.value.length === 0 ) {
				searchLabel.style.display = 'none';
			} else {
				searchLabel.style.display = 'block';
			}
		};
		searchSubmit.onclick = function( e ) {
			if ( ! search.classList.contains( 'search__open' ) ) {
				e.preventDefault();
				openSearch();
			}
			e.stopPropagation();
		};
		searchClose.onclick = function() {
			closeSearch();
		};

		document.addEventListener( 'click', function() {
			if ( window.innerWidth > 767 && document.getSelection().toString().length === 0 ) {
				closeSearch();
			}
		} );
		document.addEventListener( 'keydown', function( e ) {
			if ( e.code === 'Escape' ) {
				closeSearch();
			}
		} );

		// Focus trapping example taken from: https://medium.com/@im_rahul/focus-trapping-looping-b3ee658e5177
		function MobileMenuKeyboardHandler( e ) {
			/// Get all links from menu.
			const menuLinks = document.getElementById( 'site-navigation' ).getElementsByTagName( 'a' );

			if ( menuLinks ) {
				// Nav close button.
				const navCloseButton = document.getElementById( 'mobile-nav-close' );

				// Get last link from menu.
				const lastLinkInMenuIndex = menuLinks.length - 1;

				// Get last link from menu.
				const lastLinkInMenu = menuLinks[ lastLinkInMenuIndex ];

				if ( e.key === 'Tab' ) {
					// Rotate Focus
					// eslint-disable-next-line @wordpress/no-global-active-element
					if ( e.shiftKey && document.activeElement === navCloseButton ) {
						e.preventDefault();
						lastLinkInMenu.focus();
						// eslint-disable-next-line @wordpress/no-global-active-element
					} else if ( ! e.shiftKey && document.activeElement === lastLinkInMenu ) {
						e.preventDefault();
						navCloseButton.focus();
					}
				}
			}
		}
		document.addEventListener( 'keydown', MobileMenuKeyboardHandler );

		function handleAriaRole() {
			// When DOM is loaded role attribute will be added to navigation.
			if ( window.innerWidth < 768 ) {
				document.getElementById( 'site-navigation' ).setAttribute( 'role', 'dialog' );
				document.getElementById( 'site-navigation' ).setAttribute( 'aria-modal', 'true' );
			}

			// Handle resizing and based on the screen size,
			// role will be added or removed from navigation.
			addEventListener( 'resize', () => {
				if ( window.innerWidth < 768 ) {
					document.getElementById( 'site-navigation' ).setAttribute( 'role', 'dialog' );
					document.getElementById( 'site-navigation' ).setAttribute( 'aria-modal', 'true' );
				} else {
					document.getElementById( 'site-navigation' ).removeAttribute( 'role', 'dialog' );
					document.getElementById( 'site-navigation' ).removeAttribute( 'aria-modal', 'true' );
				}
			} );
		}

		handleAriaRole();

		// Language switcher.
		const langToggle = document.querySelector( '#site-header-menu-lang__toggle' );
		const toggleArrow = langToggle.lastElementChild;
		const langMenuPanel = document.querySelector( '#site-header-menu-lang__panel' );

		const toggleLanguageMenu = () => {
			if ( langToggle.hasAttribute( 'aria-controls' ) ) {
				langToggle.removeAttribute( 'aria-controls' );
			} else {
				langToggle.setAttribute( 'aria-controls', 'site-header-menu-lang__panel' );
			}

			toggleArrow.classList.toggle( 'reversed' );
			langMenuPanel.classList.toggle( 'visible' );

			if ( langMenuPanel.classList.contains( 'visible' ) ) {
				langToggle.setAttribute( 'aria-expanded', 'true' );
				langMenuPanel.querySelector( '.site-header-menu-lang__panel-list-item a' ).focus();
			} else {
				langToggle.setAttribute( 'aria-expanded', 'false' );
				langToggle.focus();
			}
		};

		// Event listener for click and keyboard.
		langToggle.addEventListener( 'click', toggleLanguageMenu );
		langToggle.addEventListener( 'keydown', ( event ) => {
			if ( event.key === 'Enter' ) {
				toggleLanguageMenu();
			}
		} );

		// Close the language menu with Escape key
		document.addEventListener( 'keydown', ( event ) => {
			if ( event.key === 'Escape' && langMenuPanel.classList.contains( 'visible' ) ) {
				toggleLanguageMenu();
				langToggle.focus();
			}
		} );

		// Focus trap for the language menu.
		const focusableElements = Array.from( langMenuPanel.querySelectorAll( 'a, button' ) );
		focusableElements.unshift( langToggle );
		const firstFocusableElement = focusableElements[ 0 ];
		const lastFocusableElement = focusableElements[ focusableElements.length - 1 ];

		langMenuPanel.addEventListener( 'keydown', ( event ) => {
			const activeElement = langMenuPanel.ownerDocument.activeElement;

			if ( event.key === 'Tab' ) {
				if ( event.shiftKey ) { // Shift + Tab
					if ( activeElement === firstFocusableElement ) {
						event.preventDefault();
						lastFocusableElement.focus();
					}
				} else if ( ! event.shiftKey && activeElement === lastFocusableElement ) { // Tab
					event.preventDefault();
					firstFocusableElement.focus();
				}
			}
		} );
	} );
}
